import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PostHogProvider } from 'posthog-js/react';
import { loadBrandingSync } from './helpers/preloadBrand.ts';
import App from './App.tsx';

// ————— Defer Sentry initialization until after first paint —————
if (typeof window !== 'undefined') {
  const initSentry = () => {
    import('@sentry/react').then((Sentry) => {
      Sentry.init({
        dsn: "https://00dcbb985922682ece184893f284e371@o4509336748556288.ingest.us.sentry.io/4509336760483840",
        sendDefaultPii: true,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration()
        ],
        tracesSampleRate: 0.2,
        tracePropagationTargets: [
          "localhost",
          /^https:\/\/.*\.supabase\.co/
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0
      });
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(initSentry);
  } else {
    setTimeout(initSentry, 2000);
  }
}

const queryClient = new QueryClient();

// Load branding title and favicon BEFORE React renders
loadBrandingSync();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        debug: false,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </PostHogProvider>
  </StrictMode>
);
